'use client'

import { ChevronRightIcon } from '@heroicons/react/24/outline'

import { Container } from '@src/components/Container/Container'
import { useTopNavV5 } from '@src/components/TopNavV5/TopNavV5Context'
import { TopNavV5DesktopSubMenu } from '@src/components/TopNavV5/TopNavV5Desktop/TopNavV5DesktopSubMenu'
import { cn } from '@src/utils/tailwind'

export const TopNavV5DesktopSlidingPanel = () => {
  const { setExpanded, setLeftMenuIndex, leftMenuIndex, expandedMenu, isExpanded } = useTopNavV5()

  const renderContent = () => {
    if (expandedMenu?.subMenuType === 'subMenu') {
      return <TopNavV5DesktopSubMenu />
    }

    if (expandedMenu?.subMenuType === 'leftMenu') {
      return (
        <div className="grid grid-cols-5 gap-10">
          <div className="col-span-1 border-r border-white/10 pr-5">
            <div className="flex flex-col gap-3">
              {expandedMenu?.leftMenuItems?.map((item, index) => (
                <button
                  onClick={() => setLeftMenuIndex(index)}
                  key={index}
                  className={cn(
                    'flex items-center justify-between text-body-base font-medium text-bodi-gray-butters',
                    {
                      'text-bodi-white underline': leftMenuIndex === index,
                    }
                  )}
                >
                  <div>{item.title}</div>
                  <ChevronRightIcon
                    className={cn('size-5 text-bodi-gray-medium transition-colors', {
                      'text-bodi-green-bright-500': leftMenuIndex === index,
                    })}
                  />
                </button>
              ))}
            </div>
          </div>
          <div className="col-span-4">
            <TopNavV5DesktopSubMenu />
          </div>
        </div>
      )
    }
  }

  return (
    <div
      onMouseLeave={() => setExpanded(false)}
      className={cn(
        'fixed left-0 top-12 z-40 w-full border-t border-bodi-gray-dark bg-bodi-black-text bg-gradient-to-t from-white/10 to-white/0 py-6 text-white transition-all duration-200',
        {
          'translate-y-0': isExpanded,
          'translate-y-[calc(-100%-48px)]': !isExpanded,
        }
      )}
    >
      <Container>{renderContent()}</Container>
    </div>
  )
}
